/**
 * Текстовий вміст для переглядача: декодування й підготовка JSON.
 */

/**
 * Байти → рядок. Спершу строгий UTF-8; якщо файл у ньому не читається —
 * Windows-1251: так зберігають CSV і TXT старі українські програми й Excel.
 */
export const decodeText = (buffer: ArrayBuffer): string => {
    try {
        return new TextDecoder('utf-8', { fatal: true }).decode(buffer)
    } catch {
        return new TextDecoder('windows-1251').decode(buffer)
    }
}

export type JsonPreview = { ok: true; text: string } | { ok: false; text: string }

/** JSON з відступами; якщо не розбирається — сирий текст і `ok: false`. */
export const formatJson = (text: string): JsonPreview => {
    const source = text.startsWith('﻿') ? text.slice(1) : text

    try {
        return { ok: true, text: JSON.stringify(JSON.parse(source) as unknown, null, 2) }
    } catch {
        return { ok: false, text: source }
    }
}
